export const initialData = {
  root: {
    props: {},
  },
  content: [],
  zones: {},
};

export const paddingsArray = [
  {
    label: "0px",
    value: "0px",
  },
  {
    label: "4px",
    value: "4px",
  },
  {
    label: "8px",
    value: "8px",
  },
  {
    label: "16px",
    value: "16px",
  },
  {
    label: "24px",
    value: "24px",
  },
  {
    label: "36px",
    value: "36px",
  },
  {
    label: "42px",
    value: "42px",
  },
  {
    label: "60px",
    value: "60px",
  },
  {
    label: "80px",
    value: "80px",
  },
];

export const gapsArray = [
  {
    label: "0px",
    value: "0px",
  },
  {
    label: "4px",
    value: "4px",
  },
  {
    label: "8px",
    value: "8px",
  },
  {
    label: "16px",
    value: "16px",
  },
  {
    label: "24px",
    value: "24px",
  },
  {
    label: "36px",
    value: "36px",
  },
  {
    label: "42px",
    value: "42px",
  },
  {
    label: "54px",
    value: "54px",
  },
  {
    label: "66px",
    value: "66px",
  },
];

export const fontsArray = [
  {
    label: "Inter",
    value: "Inter",
  },
  {
    label: "Roboto",
    value: "Roboto",
  },
  {
    label: "Fira",
    value: "Fira",
  },
];

export const classColorsArray = [
  {
    label: "background",
    value: "background-color",
  },
  {
    label: "primary",
    value: "primary-color",
  },
  {
    label: "default-color",
    value: "texts-color",
  },
];

export const fontWeightsArray = [
  {
    label: "Light",
    value: "400",
  },
  {
    label: "Normal",
    value: "500",
  },
  {
    label: "Bold",
    value: "700",
  },
];

export const sizeFontsArray = [
  {
    label: "16px",
    value: "16px",
  },
  {
    label: "24px",
    value: "24px",
  },
  {
    label: "28px",
    value: "28px",
  },
  {
    label: "32px",
    value: "32px",
  },
  {
    label: "36px",
    value: "36px",
  },
  {
    label: "42px",
    value: "42px",
  },
  {
    label: "50px",
    value: "50px",
  },
];

export const justifyContentArray = [
  { label: "flex-start", value: "flex-start" },
  { label: "flex-end", value: "flex-end" },
  { label: "center", value: "center" },
  { label: "space-between", value: "space-between" },
  { label: "space-around", value: "space-around" },
  { label: "space-evenly", value: "space-evenly" },
];

export const alignItemsArray = [
  { label: "stretch", value: "stretch" },
  { label: "flex-start", value: "flex-start" },
  { label: "flex-end", value: "flex-end" },
  { label: "center", value: "center" },
  { label: "baseline", value: "baseline" },
];

export const trueFalseArray = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const textAlignArray = [
  {
    label: "start",
    value: "start",
  },
  {
    label: "end",
    value: "end",
  },
  {
    label: "left",
    value: "left",
  },
  {
    label: "right",
    value: "right",
  },
  {
    label: "center",
    value: "center",
  },
];

export const rightLeftArray = [
  {
    label: "right",
    value: "right",
  },
  {
    label: "left",
    value: "left",
  },
];

export const iconsSizesArray = [
  { label: "18", value: "18" },
  { label: "24", value: "24" },
  { label: "36", value: "36" },
  { label: "48", value: "48" },
  { label: "60", value: "60" },
  { label: "72", value: "72" },
  { label: "90", value: "90" },
  { label: "104", value: "104" },
];

export const iconsNamesArray = [
  { label: "Arrow Left", value: "arrow-left" },
  { label: "Arrow Right", value: "arrow-right" },
  { label: "Ban", value: "ban" },
  { label: "Book", value: "book" },
  { label: "Bookmark", value: "bookmark" },
  { label: "Building", value: "building" },
  { label: "Calendar", value: "calendar" },
  { label: "Cancel", value: "cancel" },
  { label: "Check", value: "check" },
  { label: "Check Circle", value: "check-circle" },
  { label: "Chevron Down", value: "chevron-down" },
  { label: "Chevron Left", value: "chevron-left" },
  { label: "Chevron Right", value: "chevron-right" },
  { label: "Chevron Up", value: "chevron-up" },
  { label: "Circle", value: "circle" },
  { label: "Circle Minus", value: "circle-minus" },
  { label: "Circle Plus", value: "circle-plus" },
  { label: "Delete", value: "delete" },
  { label: "Download", value: "download" },
  { label: "Fullscreen", value: "fullscreen" },
  { label: "Funnel", value: "funnel" },
  { label: "Graduation Cap", value: "graduation-cap" },
  { label: "House", value: "house" },
  { label: "Key", value: "key" },
  { label: "Layout Grid", value: "layout-grid" },
  { label: "Leaf", value: "leaf" },
  { label: "List Filter", value: "list-filter" },
  { label: "Log In", value: "log-in" },
  { label: "Log Out", value: "log-out" },
  { label: "Menu", value: "menu" },
  { label: "Message Circle", value: "message-circle" },
  { label: "Minus", value: "minus" },
  { label: "Plus", value: "plus" },
  { label: "Refresh Cw", value: "refresh-cw" },
  { label: "Rotate Cw", value: "rotate-cw" },
  { label: "Search", value: "search" },
  { label: "Settings", value: "settings" },
  { label: "Shield", value: "shield" },
  { label: "Shopping Cart", value: "shopping-cart" },
  { label: "Square", value: "square" },
  { label: "Star", value: "star" },
  { label: "Toggle Left", value: "toggle-left" },
  { label: "Toggle Right", value: "toggle-right" },
  { label: "Undo", value: "undo" },
  { label: "User", value: "user" },
  { label: "Zoom In", value: "zoom-in" },
  { label: "Zoom Out", value: "zoom-out" },
];
